export enum NotificationIndexBoxType {
    VirtualClass = 4,
    Activity = 1,
    Completed = 6,
    Message = 0,
    Help = 5,
    Exam = 2,
    Assignment = 3
}